import React from 'react';

import _ from 'lodash';
// import dayjs from 'dayjs';

import { UserType } from '_libs/microsoft/types';

import Table from '../atoms/Table';
import TableBody from '../atoms/TableBody';
import TableHead from '../atoms/TableHead';
import TableHeader from '../atoms/TableHeader';
import TableRow from '../atoms/TableRow';
import TableData from '../atoms/TableData';

const SubscriptionTable = ({
  subscriptions,
  userType,
}: {
  subscriptions: any[];
  userType: UserType;
}):  JSX.Element => {
  if (!subscriptions || subscriptions.length === 0) {
    return (
      userType === 'publisher'
        ?
          <div>
            Could not load subscriptions.
          </div>
        :
          <div>
            Could not find subscriptions associated with your account.
          </div>
    );
  } else {
    const content = [];
    _.each(subscriptions, (subscription, i) => {
      // FIXME: Publisher and subscriber data should not vary.
      const data = (userType === 'publisher') ? subscription : subscription.meta;
      // TODO: Pull associated contact information
      const email = (userType === 'publisher') ? data.beneficiary.emailId : data.subscription.beneficiary.emailId;
      const name = (userType === 'publisher') ? data.name : data.subscriptionName;
      // const lastModified = (userType === 'publisher') ? data.lastModified : data.subscription.lastModified;
      const subscriptionId = (userType === 'publisher') ? data.microsoftSubscriptionId : data.subscription.id;
      // const status = (userType === 'publisher') ? data.saasSubscriptionStatus : data.subscription.saasSubscriptionStatus; 
      content.push(
        <TableRow key={i}>
          <TableData>{email}</TableData>
          <TableData>{name.length > 0 ? name : <em>No subscription name given.</em>}</TableData>
          {/*
            NOTE: Hide this data until subscription data is pulled directly from the Microsoft API
            data could be out of date
            <TableData>{data.planId}</TableData>
            <TableData>{dayjs(lastModified).format('M/D/YY H:mm A')}</TableData>
            <TableData>{status}</TableData>
          */}
          <TableData>
            <a href={`/microsoft/${userType}/details/${subscriptionId}`}>View Details &#8594;</a>
          </TableData>
        </TableRow>
      );
    });
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>Email</TableHeader>
            <TableHeader>Subscription Name</TableHeader>
            {/*
              NOTE: Hide this data until subscription data is pulled directly from the Microsoft API
              data could be out of date
              <TableHeader>Plan</TableHeader>
              <TableHeader>Last Updated</TableHeader>
              <TableHeader>Status</TableHeader>
            */}
            <TableHeader>Action</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {content}
        </TableBody>
      </Table>
    );
  }
};

export default SubscriptionTable;
